import React, { lazy, Suspense } from 'react';
import type { DailyTimeReportProps } from './DailyTimeReport';
const LazyDailyTimeReport = lazy(async () => await import ('./DailyTimeReport'));

const DailyTimeReport = (props: DailyTimeReportProps) => (
  <Suspense fallback={null}>
    <LazyDailyTimeReport {...props} />
  </Suspense>
);

export default DailyTimeReport;
